var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErase(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,16.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003d5b",
    d: "M61 126 c-24 -24 -29 -36 -20 -41 9 -6 5 -14 -16 -31 -18 -14 -26 -28 -22 -38 9 -24 32 -19 52 10 12 19 20 23 29 15 9 -8 21 -2 45 23 l33 34 -28 31 c-15 17 -30 31 -34 31 -3 0 -21 -15 -39 -34z m56 -24 c-10 -13 -8 -14 13 -7 25 8 25 8 6 -14 l-19 -21 -29 27 c-26 24 -27 28 -12 44 14 16 17 16 34 1 16 -13 17 -19 7 -30z m-36 -28 c23 -25 23 -26 3 -20 -16 5 -26 0 -38 -19 -10 -14 -22 -23 -28 -19 -7 5 -2 15 16 29 18 14 25 27 20 38 -9 24 -1 21 27 -9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErase);
export default __webpack_public_path__ + "static/media/iconErase.f86c396d3f82f0d331f8081e720c3a46.svg";
export { ForwardRef as ReactComponent };